// extracted by mini-css-extract-plugin
export var card = "Journey-module--card--2NstF";
export var sideIcon = "Journey-module--sideIcon--11Fs8";